import { css } from "@vitality-ds/system";
export default css({
  $$spacing: "$space$sm",
  svg: {
    $$size: "1rem",
    width: "$$size",
    height: "$$size",
    opacity: 0.8,
    verticalAlign: "text-bottom",
    "altGlyph, line, circle, ellipse, path, polygon, polyline, rect, text, textPath, tref, tspan,": {
      stroke: "currentColor"
    }
  },
  variants: {
    spacing: {
      end: {
        marginInlineEnd: "$$spacing",
        marginInlineStart: "-$sm"
      },
      start: {
        marginInlineEnd: "-$sm",
        marginInlineStart: "$$spacing"
      }
    },
    size: {
      "default": {},
      compact: {
        $$spacing: "$space$xs"
      }
    }
  }
});